// extracted by mini-css-extract-plugin
export default {"magazine":"styles_magazine__nJe38","App":"styles_App__PRrqy","tox-tinymce":"styles_tox-tinymce__uulXz"};